export interface SpecialPermissions {
    canReassignCS: boolean;
    canUnassignCS: boolean;
    canReassignCL: boolean;
    canUnassignCL: boolean;
    canAddQm: boolean;
    canEditQualificationMapping: boolean;
    canAssignQm: boolean;
    canBulkSetAutMatchSettings: boolean;
    canBulkSetQmAutMatchSettings: boolean;
}

export function toSpecialPermissions(value: Partial<SpecialPermissions>): SpecialPermissions {
    return {
        canReassignCL: value?.canReassignCL ?? false,
        canUnassignCL: value?.canUnassignCL ?? false,
        canReassignCS: value?.canReassignCS ?? false,
        canUnassignCS: value?.canUnassignCS ?? false,
        canAddQm: value?.canAddQm ?? false,
        canEditQualificationMapping: value?.canEditQualificationMapping ?? false,
        canAssignQm: value?.canAssignQm ?? false,
        canBulkSetAutMatchSettings: value?.canBulkSetAutMatchSettings ?? false,
        canBulkSetQmAutMatchSettings: value?.canBulkSetQmAutMatchSettings ?? false
    };
}
